import React, { Component } from 'react';
import SignUpStep1 from './SignUpStep1';
import SignUpStep2 from './SignUpStep2';
import ConfirmDialog from '../Components/ConfirmDialog';
import { getAppView } from '../Networking/APIClient';

let self;
let t;


class SignUp extends Component {
    constructor(props) {
        super(props);
        self = this;
        t = props.t;

        this.state = {
            registration_id: null,
            customerData: null,

            currentStep: 1,
            showDialog: false,

            dialog1: {
                bpapi_status: null,
                ok_detailed_information: null,
                success: false,
            },
            dialog2: {
                success: false
            },
        }
    }

    openFirstDialog(bpapi_status, ok_detailed_information, credentials, registration_id) {
        self.setState({
            showDialog: true,
            dialog1: {
                bpapi_status: bpapi_status,
                ok_detailed_information: ok_detailed_information,
                success: ok_detailed_information !== null ? true : false
            },
            registration_id: registration_id
        });
    }

    openStep2(customerData) {
        self.setState({
            currentStep: 2,
            dialog2: {
                customerData: customerData
            },
            showDialog: false
        });
        // Make the menu unclickable
        if (self.props.setMenuIsClickable != null) {
            self.props.setMenuIsClickable(false);
        }
    }

    openSecondDialog(success) {
        self.setState({
            showDialog: true,
            dialog2: {
                success: success
            }
        });
    }

    getTitleText() {
        if (this.state.currentStep === 1) {
            if (self.state.dialog1.bpapi_status === 'ok') {
                switch (self.state.dialog1.ok_detailed_information) {
                    case 'ok_customer_already_existed_gateway_registered_on_the_existing_customer':
                        return t('ok_customer_already_existed_gateway_registered_on_the_existing_customer_title');
                    case 'ok_gateway_registered_on_value_code_customer':
                        return t('ok_gateway_registered_on_value_code_customer_title');
                    case 'ok_customer_already_existed_and_gateway_already_registered':
                        return t('ok_customer_already_existed_and_gateway_already_registered_title');
                    default:
                        return t('error');
                }
            } else {
                switch (self.state.dialog1.bpapi_status) {
                    case 'email_address_already_in_use_data_error':
                        return t('email_address_already_in_use_data_error_title');
                    case 'illegal_password_data_error':
                        return t('illegal_password_data_error_title');
                    case 'gateway_already_registered_data_error':
                        return t('gateway_already_registered_data_error_title');
                    case 'invalid_registration_id_data_error':
                        return t('invalid_registration_id_data_error_title');
                    default:
                        return t('error');
                }
            }
        } else {
            return t(self.state.dialog2.success ? 'sign_up_information_update_success_title' : 'sign_up_information_update_failure_title');
        }
    }

    getMessageText() {
        if (this.state.currentStep === 1) {
            if (self.state.dialog1.bpapi_status === 'ok') {
                switch (self.state.dialog1.ok_detailed_information) {
                    case 'ok_customer_already_existed_gateway_registered_on_the_existing_customer':
                        return t('ok_customer_already_existed_gateway_registered_on_the_existing_customer_message');
                    case 'ok_gateway_registered_on_value_code_customer':
                        return t('ok_gateway_registered_on_value_code_customer_message');
                    case 'ok_customer_already_existed_and_gateway_already_registered':
                        return t('ok_customer_already_existed_and_gateway_already_registered_message');
                    default:
                        return t('something_went_wrong_please_try_again');
                }
            } else {
                switch (self.state.dialog1.bpapi_status) {
                    case 'email_address_already_in_use_data_error':
                        return t('email_address_already_in_use_data_error_message');
                    case 'illegal_password_data_error':
                        return t('illegal_password_data_error_message');
                    case 'gateway_already_registered_data_error':
                        return t('gateway_already_registered_data_error_message');
                    case 'invalid_registration_id_data_error':
                        return t('invalid_registration_id_data_error_message');
                    default:
                        return t('something_went_wrong_please_try_again');
                }
            }
        } else {
            return t(self.state.dialog2.success ? 'sign_up_information_update_success_message' : 'sign_up_information_update_failure_message');
        }
    }

    getButtonText() {
        return t('ok');
    }

    onButtonClicked = e => {
        e.preventDefault();

        // First dialog. Download any existing data we find on the customer.
        if (this.state.currentStep === 1) {
            if (self.state.dialog1.bpapi_status === 'ok') {
                const onOk = function onOk(bpapi_result) {
                    // Todo: progress bar
                    self.openStep2(bpapi_result.customer);
                };

                const onError = function onError() {
                    console.log("error");
                };

                getAppView(self.props.credentials, "FullAccess", onOk, onError);
            } else {
                self.props.comingFromLogin ?
                    self.props.updatePage('login')
                    :
                    self.setState({
                        showDialog: false
                    });
            }
        } else {
            // Second dialog
            if (self.state.dialog2.success) {
                if (self.props.comingFromLogin) {
                    // Go back to login if on login page
                    self.props.updatePage('login');
                } else {
                    // Update app data if inside app. Go to account overview
                    self.props.setUsingValueCode(false);
                    self.props.setLimitedAccess(false);
                    self.props.updateAppData();
                    self.props.updatePage('account_overview');
                }
            }
        }
    }

    getLog() {
        return window.console.log;
    }

    render() {
        let content;
        let myDialog =
            <ConfirmDialog
                titleText={this.getTitleText()}
                messageText={this.getMessageText()}
                buttonText={this.getButtonText()}
                onButtonClicked={e => this.onButtonClicked(e)}
                open={this.state.showDialog}
            />;
        switch (this.state.currentStep) {
            case 1:
                content =
                    <SignUpStep1
                        data={this.props.data}
                        usingValueCode={this.props.usingValueCode}
                        credentials={this.props.credentials}
                        setCredentials={this.props.setCredentials}
                        setUsingValueCode={this.props.setUsingValueCode}
                        t={this.props.t}
                        updatePage={this.props.updatePage}
                        comingFromLogin={this.props.comingFromLogin}
                        openFirstDialog={this.openFirstDialog} />
                break;
            case 2:
                content =
                    <SignUpStep2
                        setMenuIsClickable={this.props.setMenuIsClickable}
                        credentials={this.props.credentials}
                        usingValueCode={this.props.usingValueCode}
                        t={this.props.t}
                        customerData={this.state.dialog2.customerData}
                        comingFromLogin={this.props.comingFromLogin}
                        registration_id={this.state.registration_id}
                        openFinalFeedbackDialog={this.openSecondDialog} />
                break;
            default:
                content = <p>Something went wrong. Please refresh the page.</p>
                break;
        }

        return (
            <div>
                {this.state.showDialog ? myDialog : null}
                {content}
            </div>
        );
    }
}

export default SignUp;


// WEBPACK FOOTER //
// ./src/Pages/SignUp.js